import { has } from '@pogokid/util/lodash'
import {
  JSONSchemaStandardProperty,
  SchemaWithId,
} from './types'

export function isSchemaWithId<T>(
  doc: SchemaWithId<T> | T | null | undefined,
): doc is SchemaWithId<T> {
  return !!doc && has('id', doc)
}

export function isJSONSchemaStandardProperty(
  p: unknown,
): p is JSONSchemaStandardProperty {
  return (
    !!p && typeof p === 'object' && ('type' in p || '$ref' in p)
  )
}
